/* eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom';

const LinkAnchor = (props) => {
    const { children, link, useAnchor, target, options, testId, 'data-testid': dataTestId } = props;

    return (
        useAnchor ? (
            <a href={link?.startsWith('app:') ? link.replace('app:', '') : link} target={target || `_self`} data-test={testId} data-testid={dataTestId}>{children}</a>
        ) : (
            <Link to={link?.startsWith('app:') ? link.replace('app:', '') : link} target={target || `_self`} data-test={testId} data-testid={dataTestId}>{children}</Link>
        )
    );
};

export default LinkAnchor;
